import "./styles/ress.css"
import "./styles/app.scss"
import "./styles/layout.scss"
import "./styles/media.scss"

import React, { lazy, Suspense } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter, Route, Routes } from "react-router-dom"

const Home = lazy(() => import("./Pages/Home"))
const MinicogStart = lazy(() => import("./Pages/MinicogStart"))
const MinicogRemember = lazy(() => import("./Pages/MinicogRemember"))
const MinicogClock = lazy(() => import("./Pages/MinicogClock"))
const MinicogBeforeAnswer = lazy(() => import("./Pages/MinicogBeforeAnswer"))
const MinicogAnswer = lazy(() => import("./Pages/MinicogAnswer"))
const MeasureResult = lazy(() => import("./Pages/MeasureResult"))
const NotFound = lazy(() => import("./Pages/NotFound"))

const App = () => {
    return (
        <BrowserRouter>
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/minicog/start" element={<MinicogStart />} />
                    <Route path="/minicog/remember" element={<MinicogRemember />} />
                    <Route path="/minicog/clock" element={<MinicogClock />} />
                    <Route path="/minicog/before_answer" element={<MinicogBeforeAnswer />} />
                    <Route path="/minicog/answer" element={<MinicogAnswer />} />
                    <Route path="/result" element={<MeasureResult />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
}

const container = document.getElementById("app")
if (container != null) {
    const root = createRoot(container)
    root.render(<App />)
}
